import { useEffect, useState } from 'react';
import Modal from '../../../components/utils/Model';
import { useDispatch, useSelector } from 'react-redux';
import portinActivationAction from '../../../redux/portinActivation/actions';
import Button from '../../../components/utils/Button';
import { useForm } from "react-hook-form";
import Alert from '../../../components/utils/Alert';

const { completePortinActivation, resetMessage, resetSucessMessage } = portinActivationAction;

const CompletePortinActivation = ({ modal, row, close, search }) => {
    const dispatch = useDispatch();
    const { completePortinActivationLoading, completePortinActivationMessage, completePortinActivationError } = useSelector((state) => state.portinActivation);
    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState('');
    const [alertText, setAlertText] = useState('');
    const { register, handleSubmit, formState: { errors } } = useForm({
        defaultValues: {
            msisdn: '',
            accountNumber: ''
        }
    });

    useEffect(() => {
        if (completePortinActivationMessage) {
            close();
        }
        if (completePortinActivationError !== null && completePortinActivationError !== undefined) {
            displayAlert(completePortinActivationError, 'alert-danger');
        }

    }, [completePortinActivationMessage, completePortinActivationError]);

    const displayAlert = (text, type) => {
        setAlertText(text);
        setAlertType(type);
        setShowAlert(true);
    };

    const alertCancel = () => {
        setShowAlert(false);
        setAlertText('');
        setAlertType('');
        dispatch(resetMessage());
        dispatch(resetSucessMessage());
    }

    const handleCompletePortin = (data) => {
        dispatch(completePortinActivation({
            activationId: row.ID,
            bulktransactionid: row.BulkTransactionID,
            msisdn: data.msisdn,
            accountNumber: data.accountNumber,
            search
        }));
    }

    return (
        <Modal
            showModal={modal}
            title={'COMPLETE PORTIN REQUEST: '}
            subTitle={<span style={{ color: '#990404' }}>{row.TransactionID}</span>}
            onHide={close}
            width={500}
            showFooter={false}
        > {showAlert && <div className='mt-4'><Alert type={alertType} text={alertText} closeBtn={alertCancel} /></div>}
            <form onSubmit={handleSubmit(handleCompletePortin)}>
                <div className="form-row">
                    <div className="col-md-12 mb-3">
                        <div className="col-md-12 mb-3">
                            <label>MSISDN</label>
                            <input
                                type="number" className="form-control" placeholder="Enter MSISDN" name="msisdn" maxLength={10} {...register("msisdn", {
                                    required: "MSISDN is required!",
                                    pattern: {
                                        value: /^[0-9]{10}$/,
                                        message: "Mobile number must be exactly 10 digits"
                                    }
                                })}

                            />
                            {errors.msisdn && (<div className="invalid-feedback"> {errors.msisdn.message} </div>
                            )}
                        </div>
                        <div className="col-md-12 mb-3">
                            <label>Account Number</label>
                            <input type="number" className="form-control" placeholder="Enter Account Number" name="accountNumber" {...register("accountNumber", {
                                required: true,
                            })} />
                            {errors.accountNumber?.type === "required" && (
                                <div className="invalid-feedback">Account Number is required !</div>
                            )}
                        </div>
                    </div>
                </div>
                <hr />
                <div className='text-right row'>
                    <div className="col-md-12">
                        <button type="button" className="btn btn-secondary mr-2" onClick={close}>Close</button>
                        <Button title="Submit" style="minWidth:80px" loading={completePortinActivationLoading} buttonClass="btn btn-primary" buttonType='submit' />
                    </div>
                </div>
            </form>
        </Modal>
    )
}

export default CompletePortinActivation;
